import { Component, EventEmitter, Injector, OnInit, Output } from '@angular/core';
import { FormComponent } from 'src/app/core/abstracts/components/form.component';
import { Pages } from 'src/app/core/routes/routes';
import { Einzelanfrage } from 'src/app/core/models/einzelanfrage';
import { Einzelauskunft } from 'src/app/core/models/einzelauskunft';
import { PiwikService } from 'src/app/shared/services/piwik';

@Component({
    selector: 'app-einzelabfrage-ergebnis',
    templateUrl: './einzelabfrage-ergebnis.component.html',
    styleUrls: ['./einzelabfrage-ergebnis.component.scss'],
})
export class EinzelabfrageErgebnisComponent extends FormComponent implements OnInit {
    public kiwi: {
        anfrage: Einzelanfrage & { anfrageZeitraumVon: string; anfrageZeitraumBis: string };
        auskunft: Einzelauskunft;
    }[] = [];
    @Output() neueAnfrage: EventEmitter<null> = new EventEmitter<null>();

    constructor(private injector: Injector, private matomo: PiwikService) {
        super(injector);
    }

    ngOnInit() {
        this.kiwi = this.storeService.getData('kiwi')?.liste;
        if (!this.kiwi) {
            this.goToPage(Pages.EINZELABFRAGE);
        }
    }

    getUrl() {
        return this.buildUrl('kiwi');
    }

    downloadFile() {
        this.matomo.trackEvent('runterladen', 'Einzelabfrage herunterladen');
    }

    private _padTo2Digits(num: number) : String {
        return num.toString().padStart(2,'0');
    };

    get filename(): String {
        const fnParts = [];
        const abfrageZeitpunkt = new Date();

        fnParts.push(abfrageZeitpunkt.getFullYear());
        fnParts.push(this._padTo2Digits(abfrageZeitpunkt.getMonth()+1));
        fnParts.push(this._padTo2Digits(abfrageZeitpunkt.getDate()));
        fnParts.push(this._padTo2Digits(abfrageZeitpunkt.getHours()));
        fnParts.push(this._padTo2Digits(abfrageZeitpunkt.getMinutes()));
        fnParts.push(this._padTo2Digits(abfrageZeitpunkt.getSeconds()));
        fnParts.push('_Datenbereitstellung_');
        fnParts.push(this.kiwi[0].anfrage.ordnungkriterium);
        fnParts.push('.pdf');

        return fnParts.join('');
    }
}
